import Button from 'Components/Atoms/Button/Button';
import Container from 'Components/Atoms/Container/Container';
import Title from 'Components/Atoms/Title/Title';
import ButtonGroup from 'Components/Molecules/ButtonGroup/ButtonGroup';
import Modal from 'Components/Molecules/Modals/Modal/Modal';
import ModalFooter from 'Components/Molecules/Modals/ModalFooter/ModalFooter';
import ModalHeader from 'Components/Molecules/Modals/ModalHeader/ModalHeader';
import { useEffect, useState } from 'react';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { connect } from 'react-redux';
import { prepareDualListBox } from 'Services/helpers';
import { StoreState } from 'Store/Reducers';
import { getActiveFieldsByEntityIdAsArray, getFieldsById } from 'Store/Settings/Fields/Selectors';
import { patchLayout } from 'Store/Settings/Layout/Actions';
import { isLayoutPatching } from 'Store/Settings/Layout/Selectors';

const LayoutFieldsModal = ({
    activeFields, onClose, id,
    fieldsById, fields, isPatching,
    ...props
}: LayoutFieldsModalProps) => {
    const [data, setData] = useState(activeFields);

    const handleSave = () => props.patchLayout(id, {
        fields: data
    });

    useEffect(() => {
        if (!isPatching && activeFields.length !== data.length) onClose();
        if (!isPatching && !activeFields.every((_, idx) => activeFields[idx] === data[idx])) onClose();
    }, [isPatching, onClose]);

    return <Modal>
        <ModalHeader>
            <Title size='large' weight='bold'>
                Velden aanpassen
            </Title>
        </ModalHeader>
        <br/>
        <Container>
            <DualListBox
                className='duallistbox'
                preserveSelectOrder
                showOrderButtons
                options={prepareDualListBox(fields)}
                selected={data}
                onChange={(value: any) => setData(value)}
            />
        </Container>
        <br/>
        <ModalFooter>
            <ButtonGroup>
                { !isPatching &&
                    <Button
                        variant="transparent"
                        onClick={() => onClose()}
                    >
                        Annuleren
                    </Button>
                }
                <Button
                    color="primary"
                    variant="solid"
                    isLoading={isPatching}
                    onClick={handleSave}
                >
                    Aanpassen
                </Button>
            </ButtonGroup>
        </ModalFooter>
    </Modal>;
} 

interface Props {
    id: any
    entity_id: any
    activeFields: any[]
    onClose: any
}

const mapState = (state: StoreState, props: Props) => ({
    fieldsById: getFieldsById(state),
    fields: getActiveFieldsByEntityIdAsArray(state, props.entity_id),
    isPatching: isLayoutPatching(state)
});

const mapDispatch = {
    patchLayout
}

type LayoutFieldsModalProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(LayoutFieldsModal);